import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import './style.css';
import Swal from 'sweetalert2';

const PaymentAdmin = () => {
    const [orders, setOrders] = useState([]);
    const [orderStats, setOrderStats] = useState({
        total: 0,
        pending: 0,
        completed: 0,
        cancelled: 0,
        refunded: 0,
        totalRevenue: 0,
    });
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        perPage: 10, // Number of orders per page
    });
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        checkAdminStatus();
    }, []);

    useEffect(() => {
        if (isAdmin) {
            fetchAllOrders(pagination.currentPage);
        }
    }, [pagination.currentPage, isAdmin]);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1'; // Check stored value
        setIsAdmin(isAdmin);

        if (isAdmin) {
            fetchAllOrders(pagination.currentPage);
        } else {
            console.error('Unauthorized: User is not an admin');
        }
    };

    const fetchAllOrders = async (page) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }

            const response = await axios.get(`https://hbmdijital.online/api/admin/orders?page=${page}&per_page=${pagination.perPage}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const or = response.data.data; // Assuming orders are under the `data` key
                setOrders(or);
                setPagination(prev => ({
                    ...prev,
                    totalPages: response.data.last_page, // Assuming `last_page` is part of the response
                }));
                calculateOrderStats(or);
            } else {
                console.error('Failed to fetch orders:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching orders:', error);
        }
    };

    const calculateOrderStats = (orders) => {
        const total = orders.length;
        const pending = orders.filter(order => order.status === 'en attente').length;
        const completed = orders.filter(order => order.status === 'completed').length;
        const cancelled = orders.filter(order => order.status === 'cancelled').length;
        const refunded = orders.filter(order => order.status === 'refunded').length;
        const totalRevenue = orders.reduce((sum, order) => sum + parseFloat(order.payment.Amount), 0);

        setOrderStats({
            total,
            pending,
            completed,
            cancelled,
            refunded,
            totalRevenue,
        });
    };

    const handlePaymentStatus = async (orderId, status) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }

            const response = await axios.put(`https://hbmdijital.online/api/admin/orders/${orderId}/payment-status`,
                { PaymentStatus: status },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    }
                }
            );

            if (response.status === 200) {
                // Fetch orders again to reflect changes
                fetchAllOrders(pagination.currentPage);
            } else {
                console.error('Failed to update payment status:', response.statusText);
            }
        } catch (error) {
            console.error('Error updating payment status:', error);
        }
    };

    const handleView = (orderID) => {
        const order = orders.find(order => order.OrderID === orderID);
        if (order && order.status === "livré") {
            handlePaymentStatus(order.OrderID, 'payé'); // Update payment status to "payé"
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Attention!',
                text: "Vous ne pouvez pas marquer cette commande comme payée tant qu'elle n'est pas livrée.",
              });
                    }
    };

    const handleDelete = (orderID) => {
        const order = orders.find(order => order.OrderID === orderID);
        if (order && order.status === "livré") {
            handlePaymentStatus(order.OrderID, 'annulé'); // Update payment status to "annulé"
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Attention!',
                text: "Vous ne pouvez pas marquer cette commande comme annulé tant qu'elle n'est pas livrée.",
              });
        }
    };

    const handlePagination = (page) => {
        setPagination(prev => ({
            ...prev,
            currentPage: page,
        }));
    };
const shouldDisableButtons = (order) => {
    
    // Disable buttons if payment status is 'pay�', 'annul�', or order status is 'livr�'
    return order.payment.PaymentStatus === 'pay�' || 
           order.payment.PaymentStatus === 'annul�' || 
           order.status === 'livr�';
};
    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                        <h1 className="text-dark display-4">Tableau de bord des paiements</h1>
                    </div>
                    <hr className="my-4" />

                    {/* Orders Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th>ID de commande</th>
                                    <th>Fournisseur</th>
                                    <th>Statut du paiement</th>
                                    <th>Produits</th>
                                    <th>Montant</th>
                                    <th>Statut</th>
                                    <th>Créé le</th>
                                    <th>Mis à jour le</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
  {orders.map((order) => (
    <tr key={order.OrderID}>
      <td>{order.OrderID}</td>
      <td>
        <strong>{order.supplier.name}</strong><br />
        Phone: {order.supplier.phone}<br />
        Custom ID: {order.supplier.custom_id}<br />
      </td>
      <td>
        Statut du paiement: {order.payment.PaymentStatus}<br />
        Montant du paiement {order.payment.Amount}<br />
        Date de paiement: {new Date(order.payment.PaymentDate).toLocaleString()}
      </td>
      <td>
        {order.order_items.map((item) => (
          <div key={item.OrderItemID}>
            <strong>{item.product.Name}</strong><br />
          </div>
        ))}
      </td>
      <td>
        <strong>{order.payment.Amount} DH</strong>
      </td>
      <td>{order.status}</td>
      <td>{new Date(order.created_at).toLocaleString()}</td>
      <td>{new Date(order.updated_at).toLocaleString()}</td>

      {/* Action Buttons */}
      <td>
<td>
    <button
        className="btn btn-info"
        onClick={() => handleView(order.OrderID)}
    disabled={order.payment.PaymentStatus === 'pay�' || order.status === 'annul�' || order.status !== 'livr�'}
    >
        Payé
    </button>
    <button
        className="btn btn-danger"
        onClick={() => handleDelete(order.OrderID)}
    disabled={order.status === 'livr�'}
    >
        Annulé
    </button>
</td>
    
</td>
    </tr>
  ))}
</tbody>


                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-center my-4">
                        <button
                            className="btn btn-secondary"
                            onClick={() => handlePagination(pagination.currentPage - 1)}
                            disabled={pagination.currentPage === 1}
                        >
                            Previous
                        </button>
                        <span className="mx-2">Page {pagination.currentPage} of {pagination.totalPages}</span>
                        <button
                            className="btn btn-secondary"
                            onClick={() => handlePagination(pagination.currentPage + 1)}
                            disabled={pagination.currentPage === pagination.totalPages}
                        >
                            Next
                        </button>
                    </div>
                </section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default PaymentAdmin;
